<template>
  <v-card>
    <div class="grid abs">
      <div class="info-block">
        <v-icon
          :large="!$vuetify.breakpoint.mobile"
          title="Doktor"
          color="white"
          >mdi-doctor</v-icon
        >
        <div class="info-item">
          <!-- <span>DOKTOR</span> -->
          <span class="font-weight-bold text-body-1">{{
            appointment.dr_firstname + " " + appointment.dr_lastname
          }}</span>
        </div>
      </div>

      <div class="info-block">
        <v-icon
          :large="!$vuetify.breakpoint.mobile"
          title="Pacijent"
          color="white"
          >mdi-account-injury</v-icon
        >
        <div class="info-item">
          <!-- <span>PACIJENT</span> -->
          <span class="font-weight-bold text-body-1">
            {{
              appointment.patient_firstname + " " + appointment.patient_lastname
            }}</span
          >
        </div>
      </div>

      <div class="info-block">
        <v-icon :large="!$vuetify.breakpoint.mobile" title="Datum" color="white"
          >mdi-calendar</v-icon
        >
        <div class="info-item">
          <!-- <span>DATUM</span> -->
          <span class="font-weight-bold text-body-1">
            {{ new Date(appointment.date).toLocaleDateString("sr-RS") }}
          </span>
        </div>
      </div>
    </div>
    <div class="carousel" v-if="appointment.images.length">
      <v-carousel
        :show-arrows="appointment.images.length > 1 ? true : false"
        class="carousel"
        height="250"
        delimiter-icon="mdi-minus"
        hide-delimiters
        hide-delimiters-background
      >
        <v-carousel-item v-for="(img, ind) in appointment.images" :key="ind">
          <v-img :src="img" class="appointment-image" contain> </v-img>
        </v-carousel-item>
        <!-- <v-btn class="info-btn" light>Vise informacija</v-btn> -->
      </v-carousel>
      <div class="chips-container">
        <v-chip
          v-for="(treatment, ind) in appointment.treatments.split(',')"
          :key="ind"
          color="teal lighten-1"
          dark
          >{{ treatment }}</v-chip
        >
      </div>
    </div>
    <div class="p-2" v-else>
      <v-img
        src="../assets/intmedius.png"
        class="appointment-image intmedius-img"
        contain
      >
        <!-- <v-btn class="info-btn">Vise informacija</v-btn> -->
      </v-img>
      <h3 class="no-img-text white--text">Pregled nema slika</h3>
      <div class="chips-container">
        <v-chip
          v-for="(treatment, ind) in appointment.treatments.split(',')"
          :key="ind"
          color="teal"
          dark
          >{{ treatment }}</v-chip
        >
      </div>
    </div>

    <!-- <v-card-title>Pregled</v-card-title> -->
    <!-- <v-card-text> </v-card-text> -->

    <v-card-actions class="card-actions">
      <v-btn icon title="Posalji mejl" color="teal lighten-1" dark
        ><v-icon large>mdi-email-arrow-right</v-icon></v-btn
      >
      <v-btn icon title="Preuzmi izvestaj" color="teal lighten-1" dark
        ><v-icon large>mdi-download</v-icon></v-btn
      >
      <v-btn
        title="Jos informacija"
        color="teal lighten-1"
        text
        href="google.com"
        >Jos informacija</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      treatments: [],
    };
  },
  props: ["appointment"],
  mounted() {
    // console.log(this.appointment.images[0]);
    // console.log(this.appointment);
    this.treatments = this.appointment.treatments?.split(",");
  },
};
</script>

<style scoped>
.appointment-image {
  height: 250px;
}

.intmedius-img {
  background-color: #26a69a;
  padding: 20px;
}

.carousel {
  /* height: 60%; */
}

.no-img-text {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.grid {
  display: flex;
  width: 100%;
  gap: 10px;
}

.info-block {
  width: 50%;
  display: flex;
  /* justify-content: space-between; */
  gap: 5px;
}

.info-item {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.info-btn {
  position: absolute;
  left: 50%;
  bottom: 0;
  /* margin: auto; */
  transform: translate(-50%, 0);
}

.chips-container {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  padding: 16px 8px;
  position: absolute;
  top: 50%;
  transform: translateY(+70%);
}

.abs {
  position: absolute;
  z-index: 5;
  /* background-color: rgba(26, 151, 138, 0.5); */
  background-color: rgba(16, 119, 108, 0.5);

  color: white;
  padding: 14px;
}

.card-actions {
  justify-content: flex-end;
  gap: 10px;
}

@media screen and (max-width: 600px) {
  .grid {
    /* flex-direction: column; */
    font-size: 12px;
  }

  /* .info-block {
    width: 100%;
  } */
}
</style>
